import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-photo',
    templateUrl: 'hc-photo.html',
    providers: []
})
export class HcPhoto {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef) {

    }

    photoArray(): any[] {

        let name = (this.blocked && this.blocked.Content == this.hpage.THotpageContent.hcPlace ? 'Places' : 'Photos');
        //let tipo = (this.blocked && this.blocked.Content == this.hpage.THotpageContent.hcPlace ? 'Places' : 'Photos');
        let array = (this.hpage.rootdata.Galerias[name] || []);
        //if (!opera) array = array.filter(photo => (photo.GaleriaModo == this.hpage.TGaleriaModo.gmPlace));
        //if (opera)  array = array.filter(photo => (photo.GaleriaModo != this.hpage.TGaleriaModo.gmPlace));

        return array;

    }

    wrapperClass(index): string {

        let result = 'cursor-pointer' + ' ' + (index >= 1 ? 'm-display-none' : '');

        if (this.blocked.Layoute == 1) result = result + ' margin-x-10 ' +
         (this.hpage.platenode(this.blocked, 'Resume', 'Molded', 'Source') ? '' : 'border-lorean-style-15');
        // if (this.blocked.Layoute == 2) result = result + ' margin-x-10';

        return result;

    }

    wrapperStyle(index): any {

        let result = {};

        let color = this.hpage.config.colors[this.blocked.Resume.Cortwo];

        if (this.blocked.Layoute == 1) {

            result = {
                'max-width': '500px',
                width: 'calc(100% - 20px)',
                'border-color': color,
                'background': 'url(' + this.hpage.platenode(this.blocked, 'Resume', 'Molded', 'Source') + ') no-repeat scroll center center / 100% 100%',
                padding: this.hpage.platenode(this.blocked, 'Resume', 'Molded', 'Source') ? '17px' : ''
            };

        } else if (this.blocked.Layoute == 2) {

            result = {
                'max-width': '500px',
                'width': 'calc(100% - 20px)',
                'border-color': 'white'
            };

            if (index === 0) result = {
                'clip-path': 'polygon(4% 0, 86% 0, 100% 100%, 0 100%)',
                ...result
            };
            if (index === 1) result = {
                'clip-path': 'polygon(4% 0, 100% 0, 80% 100%, 17% 100%)',
                ...result
            };
            if (index === 2) result = {
                'clip-path': 'polygon(10% 0, 96% 0, 100% 100%, 0 100%)',
                ...result
            };

        }

        return result;

    }

    preWrapperStyle(index): any {

        let result = {};
        if (this.blocked.Layoute == 1) {

            result = {};

        } else if (this.blocked.Layoute == 2) {

            result = {
                'padding': '20px',
                'margin': '0 -20px'
            };

            if (index === 0) result = {
                'filter': 'drop-shadow(rgb(255,255, 255) 0px 0px 2px) drop-shadow(rgb(255,255, 255) 0px 0px 3px) drop-shadow(0px 0px 8px rgb(255, 0, 0)) drop-shadow(0px 0px 8px rgb(255, 0, 0))',
                ...result
            };
            if (index === 1) result = {
                'filter': 'drop-shadow(rgb(255,255, 255) 0px 0px 2px) drop-shadow(rgb(255,255, 255) 0px 0px 3px) drop-shadow(0px 0px 8px rgb(0, 0, 255)) drop-shadow(0px 0px 8px rgb(0, 0, 255))',
                ...result
            };
            if (index === 2) result = {
                'filter': 'drop-shadow(rgb(255,255, 255) 0px 0px 2px) drop-shadow(rgb(255,255, 255) 0px 0px 3px) drop-shadow(0px 0px 8px rgb(255, 0, 0)) drop-shadow(0px 0px 8px rgb(255, 0, 0))',
                ...result
            };

        }

        return result;

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-photo/hc-photo.ts